import { useQuery } from "react-query"
import { queryKeys } from "../../client"
import api from "../../api"

const getData = async () => {
  const { data } = await api.get(`/task-processs`)
  
  return data.data
}

export const useTaskProcesses = () => {
  const { data, ...props } = useQuery(
    queryKeys.TASK_PROCESSES,
    () => getData(),
  )
  return { data, ...props }
}
